import { Box } from '../../components/UI-CHAKRA/Box';
import { Text } from '../../components/UI-CHAKRA/Text';
import { Divider } from '../../components/UI-CHAKRA/Divider';

interface MyCentralHeaderProps {
  title: string;
}

export function MyCentralHeader(props: MyCentralHeaderProps) {
  return (
    <>
      <Box p={'20px'}>
        <Text fontSize={'14px'} fontWeight={700} color={'typography.dark'}>
          {props.title}
        </Text>
      </Box>
      <Divider />
    </>
  );
}
